import { render, staticRenderFns } from "./dietLog.vue?vue&type=template&id=9c2c1d38&scoped=true&"
import script from "./dietLog.vue?vue&type=script&lang=js&"
export * from "./dietLog.vue?vue&type=script&lang=js&"
import style0 from "./dietLog.vue?vue&type=style&index=0&id=9c2c1d38&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2c1d38",
  null
  
)

component.options.__file = "dietLog.vue"
export default component.exports